import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ICONS_PATH } from './icons-path.token';

@Injectable({
    providedIn: 'root'
})
export class IconCacheService {
    private iconCache = new Map<string, Observable<SafeHtml>>();
    private http = inject(HttpClient);
    private sanitizer = inject(DomSanitizer);
    private iconsPath = inject(ICONS_PATH);

    public getIcon(iconName: string): Observable<SafeHtml> {
        if (this.iconCache.has(iconName)) {
            return this.iconCache.get(iconName);
        }

        const path = `${this.iconsPath}/${iconName}.svg`;

        const icon = this.http.get(path, { responseType: 'text' }).pipe(
            map((svgContent) => {
                // Parse and sanitize the SVG content
                const parser = new DOMParser();
                const doc = parser.parseFromString(svgContent, 'image/svg+xml');
                const svgElement = doc.documentElement;
                const innerSvgContent = svgElement.innerHTML;

                const safeSvgContent = this.sanitizer.bypassSecurityTrustHtml(innerSvgContent);

                return safeSvgContent;
            }),
            catchError((error) => {
                console.error(`Failed to load icon ${iconName}:`, error);
                return of(null);
            }),
            shareReplay(1)
        );

        this.iconCache.set(iconName, icon);

        return icon;
    }
}
